// Where the "see all" action and trending terms land. A Rails page reads `q` (+ optional `category` scope
// and `page`). The results page is URL-driven and shareable (like Google), so links point straight here.
// Extracted into its own module so both the dropdown and the connected bar can import it without a cycle.
export const searchPagePath = (
  query: string,
  opts: { category?: string; page?: number } = {}
): string => {
  const params = new URLSearchParams({ q: query })
  if (opts.category && opts.category !== "all") params.set("category", opts.category)
  if (opts.page && opts.page > 1) params.set("page", String(opts.page))
  return `/search?${params.toString()}`
}
